








































































































import { Component, Mixins, Watch, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import {
  InquiryGroup as InquiryGroupModel,
  InquiryServiceDiv,
} from "@/model/inquiry";
import { VForm } from "@/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import AppIconButton from "@/components/admin_common/AppIconButton.vue";

@Component({
  components: {
    AppAuthButton,
    AppIconButton,
  },
})
export default class InquiryGroup extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** Ref */
  @Ref("form") private readonly form!: VForm;

  private dialog = false;
  private valid = false;
  private inquiryGroups: InquiryGroupModel[] = [];
  private serviceDivs: InquiryServiceDiv[] = [];
  private editedIndex = -1;
  private editedItem: InquiryGroupModel = {
    id: 0,
    name: "",
    service_div_id: 0,
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    inquiry_sub_groups: [],
  };
  private defaultItem: InquiryGroupModel = {
    id: 0,
    name: "",
    service_div_id: 0,
    sort_no: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
    inquiry_sub_groups: [],
  };

  private headers = [
    { text: "ID", value: "id" },
    { text: "サービス種類並び順", value: "inquiry_service_div.sort_no" },
    { text: "並び順", value: "sort_no" },
    { text: "サービス種類名", value: "inquiry_service_div.name" },
    { text: "グループ名", value: "name" },
    { text: "操作", value: "actions", sortable: false },
  ];

  get formTitle() {
    return this.editedIndex === -1 ? "新規追加" : "編集";
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    val || this.close();
  }

  created() {
    this.fetchData();
  }

  private fetchData() {
    // サービス種類取得
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_service_div/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_service_divs) {
          this.serviceDivs = res.data.inquiry_service_divs;
        }
      }
    );

    // グループ取得
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiry_master/inquiry_group/get",
      {},
      (res) => {
        if (res.data && res.data.inquiry_groups) {
          this.inquiryGroups = res.data.inquiry_groups;
        }
      }
    );
  }

  private editItem(item: InquiryGroupModel) {
    this.editedIndex = this.inquiryGroups.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  private async deleteItem(item: InquiryGroupModel) {
    if (await this.$openConfirm("削除しますか？")) {
      this.postJsonCheck(
        window.base_url + "/api/admin/inquiry_master/inquiry_group/delete",
        { inquiry_group: item },
        () => {
          this.fetchData();
        }
      );
    }
  }

  private close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      if (this.form) {
        this.form.resetValidation();
      }
    });
  }

  private save() {
    if (!this.form.validate()) {
      return;
    }

    const url =
      window.base_url + "/api/admin/inquiry_master/inquiry_group/save";
    this.postJsonCheck(url, { inquiry_group: this.editedItem }, () => {
      this.fetchData();
      this.close();
    });
  }
}
